import { device } from '../utils/device';
export const dental = {
  common: { primary: '#3D61D7', secondary: '#F0454E' },
  colors: {
    primary: '#3D61D7',
    secondary: '#F0454E',
    textPrimary: '#29275F',
    textSecondary: '#929CB7',
    success: '#43D092',
    info: '#6294FF',
    error: '#D32F2F',
    warning: '#F9BE04',
    default: '#929CB7',
    white: '#FFFFFF',
    disabled: '#CCD4E6',
    cancel: '#E67B4C',
  },
  background: {
    white: '#fff',
    default: '#F7F8FA',
  },
  boxBorder: {
    default: '1px solid #CCD4E6',
    active: '1px solid #929CB7',
  },
  logos: {
    mainLogo: '../assets/牙醫logo.jpg',
    banner: '../assets/牙醫banner.jpg',
  },
  button: {
    primary: {
      background: '#3D61D7',
      border: '0px solid #0',
      hovercolor: '#000',
      hoveropacity: '25%',
      active: '2px solid #3D61D7',
      opacity: '25%',
      disabled: '#CCD4E6',
    },
    secondary: {
      background: '#fff',
      border: '2px solid #3D61D7',
      hover: '#000',
      hoveropacity: '25%',
      active: '2px solid #3D61D7',
      opacity: '25%',
      disabled: '2px solid #CCD4E6',
    },
  },
  list: {
    default: '#ffffff',
    hover: '#E4EBF9',
  },
  icon: {
    default: '#929CB7',
    disabled: '#CCD4E6',
  },
};

export const western = {
  common: { primary: '#006DB1', secondary: '#F7C767' },
  colors: {
    primary: '#006DB1',
    secondary: '#F7C767',
    textPrimary: '#202D31',
    textSecondary: '#7A8E99',
    success: '#43D092',
    success2: '#4CAF50',
    info: '#6294FF',
    error: '#F76163',
    error2: '#F44336',
    warning: '#F9BE04',
    default: '#7A8E99',
    white: '#FFFFFF',
    disabled: '#BAD3E3',
    cancel: '#E67B4C',
    body: 'rgba 0 0 0, 0.87',
    yellow: {
      50: '#FDFDEA',
      800: '#723B13',
    },
    gray: {
      100: '#F3F4F6',
      200: '#E5E7EB',
      300: '#D1D5DB',
      400: '#9CA3AF',
      500: '#6B7280',
      600: '#4B5563',
      800: '#1F2A37',
      900: '#111928',
    },
    red: {
      500: '#E02424',
      700: '#C81E1E',
    },
    blue: {
      600: '#1c64f2',
    },
    primaryColor: {
      600: '#1C64F2',
      700: '#1A56DB',
    },
  },
  background: {
    white: '#fff',
    default: '#F7F8FA',
  },
  boxBorder: {
    default: '1px solid #BAD3E3',
    active: '1px solid #7A8E99',
    primary: '1px solid rgba(0, 0, 0, 0.1)',
    secondary: '0.55vw solid #C2CFD6',
  },
  logos: {
    mainLogo: '../assets/西醫logo.jpg',
    banner: '../assets/西醫banner.jpg',
  },
  button: {
    primary: {
      background: '#006DB1',
      border: '0px solid #0',
      hover: '#000',
      hoveropacity: '25%',
      active: '2px solid #006DB1',
      opacity: '25%',
      disabled: '#BAD3E3',
    },
    secondary: {
      background: '#fff',
      border: '2px solid #006DB1',
      hover: '#000',
      hoveropacity: '25%',
      active: '2px solid #006DB1',
      opacity: '25%',
      disabled: '2px solid #BAD3E3',
    },
  },
  list: {
    default: '#ffffff',
    hover: '#D1E9F8',
  },
  icon: {
    default: '#7A8E99',
    disabled: '#BAD3E3',
  },
  font_size: {
    base: '16px',
    xs: '12px',
    sm: '14px',
    xl: '20px',
  },
  font_weight: {
    regular: 400,
    medium: 500,
    bold: 700,
  },
};

export default {
  ...western,
  device,
};
